import React, { useState, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Link as RouterLink } from 'react-router-dom';

import { Button } from '@material-ui/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Input } from '~/components/Form';
import { forgotInRequest } from '~/store/modules/esqueciminhasenha/actions';
import { validCPF } from '~/helpers';

import * as S from './styles';

const LinkBehavior = React.forwardRef((props, ref) => (
  <RouterLink ref={ref} to="/" {...props} />
));

export default function EsqueciMinhaSenha() {
  const [loading, setLoading] = useState(false);

  const formRef = useRef(null);
  const dispatch = useDispatch();

  const handleSubmit = useCallback(async (value) => {
    try {
      setLoading(true);

      const schema = Yup.object().shape({
        username: Yup.string().required('Informe um nome de usuário'),
        cpf: Yup.string()
          .typeError('Campo de preenchimento obrigatório e apenas números.')
          .required('Informe o número de CPF.')
          .test('valid-cpf', 'Informe um CPF válido', validCPF),
      });

      await schema.validate(value, {
        abortEarly: false,
      });

      const { username, cpf } = value;

      const domain = window.location.hostname.split('.')[0];

      dispatch(forgotInRequest(domain, username, cpf));
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        formRef.current.setErrors(validationErrors);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <S.Wrapper ref={formRef} onSubmit={handleSubmit}>
      <Input
        name="username"
        label="Nome de usuario"
        required
        variant="standard"
        size="medium"
      />

      <Input name="cpf" label="CPF" required variant="standard" size="medium" />

      <Button
        color="primary"
        variant="contained"
        fullWidth
        type="submit"
        disabled={loading}
      >
        {loading ? 'Carregando...' : 'Solicitar Senha'}
      </Button>

      <Button color="primary" component={LinkBehavior}>
        Fazer login
      </Button>
    </S.Wrapper>
  );
}
